import {parse} from 'qs';
import Url from 'url-parse';
import {Maybe} from '../graphql/generated/types';

/**
 * 현재 스킴이 '컨텐츠 홈'으로 이동하는 스킴인지 여부와, 컨텐츠 홈의 seriesId를 리턴하는 함수입니다.
 * 로깅을 위해 사용합니다.
 */
export function checkIfContentHomeScheme(scheme?: Maybe<string>):
  | {
      isContentHome: true;
      seriesId: string;
    }
  | {
      isContentHome: false;
      seriesId?: never;
    } {
  if (!scheme) {
    return {
      isContentHome: false,
    };
  }

  const {hostname, pathname: _pathname, query} = new Url(scheme);

  const actionGroup = hostname;
  const action = _pathname.replace(/(^\/|\/$)/g, '');
  const splittedActionList = action.split('/');
  const querystring = query.replace(/^\?/g, '');
  const parsedQueryparam = parse(querystring);

  if (actionGroup === 'open') {
    if (splittedActionList[0] === 'content') {
      const {series_id} = parsedQueryparam;
      return {
        isContentHome: true,
        seriesId: series_id as string,
      };
    }
  }

  return {
    isContentHome: false,
  };
}
